import React from 'react'

import { Size } from '@/types/size'

import SmallSVG from '../../shared/small-svg'

type AdobeProps = {
  size: Size
  small?: boolean
}
const Adobe = ({ size, small }: AdobeProps) => (
  <SmallSVG
    size={size}
    small={small}
    viewBox="0 0 39 120"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="adobe-logo" fill="#fff" transform="translate(0.000000, 35.000000)" fillRule="nonzero">
        <path
          d="M5.54552846,36.9722222 L8.50211382,49.6141975 L6.34878049,49.6141975 L5.84211382,47.2469136 L3.16666667,47.2469136 L2.67235772,49.6141975 L0.51902439,49.6141975 L3.47560976,36.9722222 L5.54552846,36.9722222 L5.54552846,36.9722222 L5.54552846,36.9722222 Z M5.43430894,45.1018519 L4.50439024,40.3703704 L3.57447154,45.1018519 L5.43430894,45.1018519 L5.43430894,45.1018519 Z"
          id="Shape"
        ></path>
        <path
          d="M16.3925203,45.0092593 C16.3925203,42.1728395 17.3780488,40.095679 19.6178862,40.095679 C21.8422764,40.095679 22.843252,42.1728395 22.843252,45.0092593 C22.843252,47.8796296 21.8299187,49.9567936 19.6178862,49.9567936 C17.3934959,49.9598765 16.3925203,47.882716 16.3925203,45.0092593 L16.3925203,45.0092593 L16.3925203,45.0092593 Z M20.8691057,45.0092593 C20.8691057,42.5154321 20.3469919,41.9382716 19.6147967,41.9382716 C19.0370732,41.9382716 18.3604878,42.3703704 18.3604878,45.0092593 C18.3604878,47.7006173 19.0370732,48.117284 19.6147967,48.117284 C20.4334959,48.117284 20.8691057,47.3580247 20.8691057,45.0092593 L20.8691057,45.0092593 Z"
          id="Shape"
        ></path>
        <g id="Group">
          <path
            d="M18.7003252,12.191358 C18.7404878,12.2314815 27.4063415,31.9783951 27.3970806,31.962972 C25.5001626,31.962972 23.6125203,31.962972 21.7186992,31.962972 C21.7186992,31.9012346 19.0278049,25.5246914 19.0556098,25.4907407 C17.0104065,25.4907407 14.977561,25.4907407 12.9323577,25.4907407 C12.9879675,25.5061728 18.7837398,12.1234568 18.7003252,12.191358 L18.7003252,12.191358 Z"
            id="Path"
          ></path>
          <path
            d="M0.24097561,0.0617174028 C0.284227642,0.0617174028 13.5502439,0.0617174028 13.5534244,0.0617174028 C13.5934959,0.0524691358 0.330569106,31.9567901 0.287317073,31.9167045 C0.284227642,31.8734568 0.253333333,0.0401234568 0.24097561,0.0617174028 L0.24097561,0.0617174028 Z"
            id="Path"
          ></path>
          <path
            d="M23.6866667,0.0617283951 L37.4500813,0.0617283951 C37.4500813,0.141975309 37.440813,31.9783951 37.440813,31.9323565 C37.4500813,32.037037 23.6866667,0.0617283951 23.6866667,0.0617283951 L23.6866667,0.0617283951 Z"
            id="Path"
          ></path>
          <path
            d="M13.4482927,49.5925926 L13.3926829,48.4907407 L13.321626,48.4907407 C13.0250407,49.3580247 12.3917073,49.9351852 11.5884553,49.9351852 C9.68845528,49.9351852 8.88520325,47.712963 8.88520325,44.9691358 C8.88520325,42.6203704 9.47528455,40.0740741 11.6162602,40.0740741 C12.3639024,40.0740741 12.7160976,40.345679 13.2505691,41.0493827 L13.2505691,36.9506173 L15.1505691,36.9506173 L15.1505691,49.5925926 L13.4482927,49.5925926 L13.4482927,49.5925926 L13.4482927,49.5925926 Z M12.0982114,41.9351852 C11.5760976,41.9351852 10.8593496,42.441358 10.8593496,45.0061728 C10.8593496,46.1975309 11.0138211,48.1141975 12.0982114,48.1141975 C13.1393496,48.1141975 13.3370732,46.3981481 13.3370732,45.0061728 C13.3370732,42.441358 12.604878,41.9351852 12.0982114,41.9351852 L12.0982114,41.9351852 Z"
            id="Shape"
          ></path>
          <path
            d="M25.9543089,49.5925926 L24.2520325,49.5925926 L24.2520325,36.9506173 L26.1674797,36.9506173 L26.1674797,41.1604938 C26.5629268,40.2561728 27.3074797,40.0771605 27.7863415,40.0771605 C29.8006504,40.0771605 30.5328455,42.191358 30.5328455,44.9722222 C30.5328455,47.7345679 29.8160976,49.9382716 27.8017886,49.9382716 C26.9707317,49.9382716 26.4764228,49.5216049 26.0686179,48.4938272 L26.0130081,48.4938272 L25.9543089,49.5925926 L25.9543089,49.5925926 L25.9543089,49.5925926 Z M27.3198374,48.095679 C28.3609756,48.095679 28.5586992,46.3796296 28.5586992,44.9876543 C28.5586992,42.4228395 27.8265041,41.9166667 27.3198374,41.9166667 C26.7977236,41.9166667 26.0809756,42.4228395 26.0809756,44.9876543 C26.0809756,46.1790123 26.2354472,48.095679 27.3198374,48.095679 L27.3198374,48.095679 Z"
            id="Shape"
          ></path>
        </g>
        <path
          d="M37.6447154,46.9598765 C37.1658537,49.7407407 35.6180488,49.9567901 34.5738211,49.9567901 C33.4060163,49.9567901 31.404065,49.5246914 31.404065,45.0092593 C31.404065,41.867284 32.6985366,40.095679 34.7128455,40.095679 C35.9795122,40.095679 37.7682927,40.7993827 37.7682927,45.1882716 L37.7682927,45.6944444 L33.375122,45.6944444 C33.375122,47.8611111 34.1227642,48.1141975 34.6572358,48.1141975 C35.0928455,48.1141975 35.5439024,47.9876543 35.7261789,46.9567901 L37.6447154,46.9567901 L37.6447154,46.9598765 L37.6447154,46.9598765 Z M35.7972358,44.1604938 C35.741626,42.2993827 35.2905691,41.9382716 34.6572358,41.9382716 C33.5728455,41.9382716 33.3905691,43.4722222 33.375122,44.1604938 L35.7972358,44.1604938 L35.7972358,44.1604938 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </SmallSVG>
)

Adobe.defaultProps = {
  size: {
    width: 39,
    height: 120,
  },
}

export default Adobe
